import {Spinner,  Badge, Button, Flex, Table, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue, Icon, Alert} from '@chakra-ui/react'; 


import * as React from 'react';



import { 
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getFacetedRowModel,
  getFacetedUniqueValues,
  getFacetedMinMaxValues,
  flexRender, 
} from '@tanstack/react-table'

export default function CommonDatatable(props: { 
  tableData: any ;
  columnsDefinition: any;
	actionContent?: JSX.Element;
	headerContent?: JSX.Element;
	footerContent?: JSX.Element;
  showEmptyState: Boolean;
  isLoading: Boolean;
}) {
	const { tableData, actionContent, columnsDefinition, footerContent, showEmptyState, isLoading, headerContent } = props;
	
    const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");  

  
  let columns = columnsDefinition; 
  const [globalFilter, setGlobalFilter] = React.useState('')

  const table = useReactTable({
    data: tableData,
    columns, 
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter, 
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedRowModel: getFacetedRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getFacetedMinMaxValues: getFacetedMinMaxValues(),
    debugTable: true,
    debugHeaders: true,
    debugColumns: false,
  })



  return ( 
      <Flex 
        direction='column'
        w='100%'>
            <Flex
            align={{ sm: "flex-start", lg: "flex-start" }}
            justify={{ sm: "flex-start", lg: "flex-start" }}
            w='100%'
            px='22px'>
             {actionContent}
            </Flex> 
            { headerContent ? <Flex
            align={{ sm: "flex-start", lg: "flex-start" }}
            justify={{ sm: "flex-start", lg: "flex-start" }}
            w='100%'
            px='22px'>
             {headerContent}
            </Flex> : <> </>}
          {  table.getRowModel().rows.length === 0 ? 
            (isLoading ? <Spinner
              thickness='4px'
              speed='0.65s'
              emptyColor='gray.200'
              m='15px'
              color='blue.500'
              size='md'
            /> : (
              showEmptyState ? <></> : <Flex><Alert m="10px"  variant='left-accent'>No se han encontrado resultados que cumplan con los criterios de búsqueda. </Alert></Flex>)) :
              <Flex 
              direction='column'
              w='100%'
              overflowX={{ sm: "scroll", lg: "auto" }} overflowY='auto'>
      <Table variant='striped' colorScheme='brand' size='sm' mt='15px'>
        <Thead>
          {table.getHeaderGroups().map(headerGroup => (
            <Tr key={headerGroup.id}>
              {headerGroup.headers.map(header => {
                return (
                  <Th
                    pe='10px' 
                    borderColor={borderColor} key={header.id} colSpan={header.colSpan}>
                    {header.isPlaceholder ? null : ( 
                    <Flex
                          {...{
                            className: header.column.getCanSort()
                              ? 'cursor-pointer select-none'
                              : '',
                            onClick: header.column.getToggleSortingHandler(),
                          }}
                      justify='space-between'
                      align='center'
                      fontSize={{ sm: "10px", lg: "12px" }}
                      color='gray.400'> 
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                          {{
                            asc: '',
                            desc: '',
                          }[header.column.getIsSorted() as string] ?? null}
                    </Flex> 
                    )}
                  </Th>
                )
              })}
            </Tr>
          ))}
        </Thead>
        <Tbody>
          { table.getRowModel().rows.map(row => {
            return (
              <Tr px="20px" key={row.id}>
                {row.getVisibleCells().map(cell => {
                  return (
                    <Td key={cell.id}
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "150px", md: "200px", lg: "auto" }}
                        borderColor={borderColor}>
                      {flexRender(
                        cell.column.columnDef.cell,
                        cell.getContext()
                      )}
                    </Td>
                  )
                })}
              </Tr>
            )
          })}
        </Tbody>
      </Table>
      
      </Flex> 
}

      <Flex
            align={{ sm: "flex-start", lg: "flex-start" }}
            justify={{ sm: "flex-start", lg: "flex-start" }}
            w='100%'
            px='22px'>
             {footerContent}
            </Flex> 

    </Flex>
  )
} 
